import React, { useState, useContext, useEffect } from "react";
import { Utils, UserContext } from "./../../common";
import { Card, Row, Col, Modal, Button, Alert, Spinner, Table } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import moment from "moment";

const ChoosePlans = (props) => {
  const { userData, addToUserData } = useContext(UserContext);
  const [ sitePlans, setSitePlans ] = useState(false);
  const [ selplan, setSelplan ] = useState(false);
  const [askdis, setAskdis] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [making, setMaking] = useState(false);
  const [upgradeStatus,setUpgradeStatus] = useState({mode: 0, msg: ""}); //== 0: nothing, 1: success, 2: failed
  
  useEffect(() => {
    
    const handleWindowLoad = () => {
      if(typeof plans !== 'undefined') {
        setSitePlans(window['plans']);
      }
    };
    window.setTimeout(handleWindowLoad,1000);
  }, []);

  const hasActivePlan = () => {
    return _.get(userData,'plan.id',0) > 0 && moment().isBefore(_.get(userData,'plan_expires',false));
  };

  const makePayment = () => {
    setMaking(true);
    setAskdis(false);
    var usecoupon = coupon;
    setCoupon("");
    setUpgradeStatus({mode: 0});
    return axios.post(Utils.apiUrl("payment/makepayment"), `plan_id=${selplan.id}${hasActivePlan() ? '&mode=upgrade' : ''}&coupon=${usecoupon}`, Utils.apiHeaders())
    .then((res) => {
      if(hasActivePlan()){
        setMaking(false);
        if(res.data.success){
            addToUserData(res.data.data);
            props.onPayment();
            setUpgradeStatus({mode: 1,message:"Your plan have been upgraded Successfully."});
          }else{
            setUpgradeStatus({mode: 2, message: res.data.error});
        }
      }else{
        if(res.data.success){
          window.location.href = res.data.pg_url;
        }else{
          setSelplan(false);
          setMaking(false);
          setUpgradeStatus({mode: 2, message: res.data.message});
        }
      }
    });
  };

  const renderPlan = (p,showThisPlan) => {

    let planmods = JSON.parse(p.modules);
  
      return showThisPlan ? <div key={p.id} className="col-md-4 col-sm-4">
        <div className="planbox">
          <h4><b>{p.name}</b></h4>
          <ul className="autopilot mb-4">
            {window['modules'].map(m=><li key={m.id}><img src={`${process.env.PUBLIC_URL}/images/${planmods.includes(m.id) ? 'check2' : 'iclose'}.png`} alt="#" /> {m.title}</li>)}
          </ul>
          <h5><b>{p.cost} + VAT</b></h5>
          <div className="button4" onClick={()=>{setSelplan(p);setAskdis(true);}}>Choose</div>
        </div>
      </div> : <></>;
  };

  const renderPlans = () => {

    let anyplans = false;
    let showThisPlan = false;

    return <>
    {sitePlans.map(p => {
      showThisPlan = parseInt(_.get(userData,'plan.id',0)) !== parseInt(p.id);// && parseFloat(p.cost) > parseFloat(_.get(userData,'plan.cost',0));
      if(showThisPlan) { anyplans = true;}
      return renderPlan(p, showThisPlan);
    })}
    {!anyplans && <Alert variant="warning">You are already subscribed on the highest plan.</Alert>}
    </>;
  };

  const renderAskDis = () => {
    return <Modal show={askdis} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setAskdis(false)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <img src={`${process.env.PUBLIC_URL}/images/circle.png`} className="mb-3" alt="Information" style={{width: 50}} />
          <h4 className="mb-4">Coupon Code</h4>
          <input type="text" className="form-control" placeholder="Enter coupon code" onChange={(e) => setCoupon(e.currentTarget.value)} value={coupon} />
          <div className="alert alert-warning" style={{fontSize: 12}}>If you do not have any coupon code, please leave this blank and proceed with "Make Payment".</div>
          <Button variant="primary" className="d-block mx-auto mt-2 mb-4 w-100" onClick={(e)=> makePayment()}>Make Payment</Button>
        </Modal.Body>
      </Modal>
  };

  return <Row className="mt-0 mt-sm-4">
  
    
          {sitePlans===false && <Col><Spinner animation="border" role="status"></Spinner><span className="p-2">Loading Plans...</span></Col>}
          {sitePlans && <>
            {making && <Col><Spinner animation="border" role="status"></Spinner><span className="p-2">Payment initiated, please wait...</span></Col>}
            {!making && <>
              {upgradeStatus.mode > 0 && <div className="px-3"><Alert variant={upgradeStatus.mode === 1? "success" : "danger"}>{upgradeStatus.message}</Alert></div>}
              {renderPlans()}
              {askdis && renderAskDis()}
            </>}
            
          </>}
        
  </Row>;
};

export default ChoosePlans;